import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAward } from "@fortawesome/free-solid-svg-icons";

const PromoTag = ({ promoType }) => {
  switch (promoType) {
    case 'winback':
      return (
        <span className="tag lox-no-border lox-no-border has-background-pink no-radius has-text-black is-size-7 p-0 pr-1 pl-1">
          <FontAwesomeIcon icon={faAward} className="is-size-6 pr-1 pt-0" /><span>Winback Promo</span>
        </span>
      );
    case 'fresh_start':
      return (
        <span className="tag lox-no-border lox-no-border has-background-pink no-radius has-text-black is-size-7 p-0 pr-1 pl-1">
          <FontAwesomeIcon icon={faAward} className="is-size-6 pr-1 pt-0" /><span>Fresh Start</span>
        </span>
      );
    default:
      return null;
  }
}

export default PromoTag;
